export default __webpack_public_path__ + "static/media/profile.46bad381.jpeg";